export const STATUS_BERAKHIR = "Sudah Berakhir";
export const STATUS_MULAI = "Belum dimulai";
export const STATUS_TERBIT = "Sedang Berlangsung";

export default {
  STATUS_BERAKHIR,
  STATUS_MULAI,
  STATUS_TERBIT
};
